import isFunction from 'lodash/isFunction';

import { getGa } from 'core/googleAnalytics';

import { EntityType } from './types';

type EventCategory = 'ACCESS_CONTROL';

type EventAction = 'ADD_EXISTING_USER' | 'INVITE_USER' | 'REMOVE_ACCESS';

type ReportPayload = {
  hitType: 'event';
  eventCategory: EventCategory;
  eventAction: EventAction;
  eventLabel?: string;
};

const report = (payload: ReportPayload) => {
  const ga = getGa();

  if (!isFunction(ga)) {
    return;
  }

  ga('send', payload);
};

export const reportInviteUser = (entityType: EntityType) => {
  report({
    hitType: 'event',
    eventCategory: 'ACCESS_CONTROL',
    eventAction: 'INVITE_USER',
    eventLabel: entityType,
  });
};

export const reportAddExistingUser = (entityType: EntityType) => {
  report({
    hitType: 'event',
    eventCategory: 'ACCESS_CONTROL',
    eventAction: 'ADD_EXISTING_USER',
    eventLabel: entityType,
  });
};

export const reportRemoveAccess = (entityType: EntityType) => {
  report({
    hitType: 'event',
    eventCategory: 'ACCESS_CONTROL',
    eventAction: 'REMOVE_ACCESS',
    eventLabel: entityType,
  });
};
